import React from 'react';
import { Inspector, Thumbnail } from '@bynder/design-system';
import { useActiveWidget } from '../../../../queries/guides';
import { ContentColorPaletteWidget, WIDGET_TYPE } from '../../../../types';
import { useColorPaletteWidgetMutations } from '../../../../mutations/widgets/colorPalette';
import { WidgetSettingsHeader } from '../../Styles';
import { useInspectorStore } from '../../../../stores/inspectorStore';
import CustomCssStyleEditor from '../CustomCSSEditor';
import { isDevelopment } from '../../../../constants/app';
import ColorPaletteModes from './ColorPaletteWidgetSettings/ColorPaletteModes';
import ColorPaletteName from './ColorPaletteWidgetSettings/ColorPaletteName';
import ColorPaletteValue from './ColorPaletteWidgetSettings/ColorPaletteValue';
import { CSS_PROPERTIES } from '../constants';
import InspectorBorderRadius from '../InspectorBorderRadius';
import { IconBorder } from '@bynder/icons';
import { SettingsAccordion } from '../SettingsAccordion';
import { useTranslate } from '@bynder/localization';
import { useWidgetStyleProperty } from '../helpers';

export const ColorPaletteWidgetSettings: React.FC = () => {
  const { translate } = useTranslate();
  const widgetSettings = useInspectorStore(s => s.widgetSettings);
  const { editStyle } = useColorPaletteWidgetMutations(
    widgetSettings.sectionId,
    widgetSettings.columnIndex,
    widgetSettings.widgetId,
  );
  const widget = useActiveWidget() as ContentColorPaletteWidget;

  const handleStyleChange = (style: string) => {
    editStyle.mutate({ style });
  };

  const { value: borderRadius, origin: borderRadiusOrigin } =
    useWidgetStyleProperty(
      widget.style.stylesheet,
      'widgets.colorPalette.borderRadius',
      CSS_PROPERTIES.BORDER_RADIUS,
    );

  return (
    <>
      <WidgetSettingsHeader widgetType={WIDGET_TYPE.COLOR_PALETTE} />

      <Inspector.Divider />
      <ColorPaletteName
        style={widget.style.stylesheet}
        handleStyleChange={handleStyleChange}
      />
      <Inspector.Divider />
      <ColorPaletteModes
        style={widget.style.stylesheet}
        handleStyleChange={handleStyleChange}
      />
      <Inspector.Divider />
      <ColorPaletteValue
        style={widget.style.stylesheet}
        handleStyleChange={handleStyleChange}
      />
      <Inspector.Divider />
      <SettingsAccordion
        noDivider
        thumbnail={<Thumbnail icon={<IconBorder />} />}
        title={translate('WIDGETS_INSPECTOR.BORDER_RADIUS')}
      >
        <InspectorBorderRadius
          style={widget.style.stylesheet}
          handleStyleChange={handleStyleChange}
          borderRadius={borderRadius}
          origin={borderRadiusOrigin}
        />
      </SettingsAccordion>
      <Inspector.Divider />

      {isDevelopment && (
        <CustomCssStyleEditor
          handleChange={() => editStyle.mutate({ style: '' })}
          label="Section CSS"
          placeholder="Enter your custom CSS here"
          style={widget?.style?.stylesheet}
        />
      )}
    </>
  );
};
